import { render } from "./TaxReportCustom2022.vue?vue&type=template&id=460564ec&scoped=true"
import script from "./TaxReportCustom2022.vue?vue&type=script&lang=js"
export * from "./TaxReportCustom2022.vue?vue&type=script&lang=js"

import "./TaxReportCustom2022.vue?vue&type=style&index=0&id=460564ec&scoped=true&lang=css"
import "./TaxReportCustom2022.vue?vue&type=style&index=1&id=460564ec&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-460564ec"]])

export default __exports__